import { render, staticRenderFns } from "./layout-head.vue?vue&type=template&id=748509aa&scoped=true"
import script from "./layout-head.vue?vue&type=script&lang=js"
export * from "./layout-head.vue?vue&type=script&lang=js"
import style0 from "./layout-head.vue?vue&type=style&index=0&id=748509aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748509aa",
  null
  
)

export default component.exports